import { CONTRACTOR_AGREEMENT_VERSIONS } from "@src/lib/interface/src";

export const LATEST_CONTRACTOR_AGREEMENTS = [
  CONTRACTOR_AGREEMENT_VERSIONS.V3,
  CONTRACTOR_AGREEMENT_VERSIONS.V4,
  CONTRACTOR_AGREEMENT_VERSIONS.V5,
];
